<template>
    <v-card outlined class="tour-ticket rounded-xl overflow-hidden">
        <div class="tour-ticket__bar" :class="isPast ? 'grey' : 'primary'"></div>
        <div class="pa-4 pa-sm-5">
            <div class="d-flex align-center justify-space-between mb-3">
                <div class="details-text muted--text text-truncate me-2">{{ booking.tour.title }}</div>
                <v-chip small label :color="status.color" dark class="font-weight-bold flex-shrink-0">
                    <v-icon left small>{{ status.icon }}</v-icon>
                    {{ status.text }}
                </v-chip>
            </div>

            <!-- Past ticket: a compact stamp, no live QR (a second scan would only be rejected at the gate). -->
            <template v-if="isPast">
                <div class="strong-text--text font-weight-bold mb-1">{{ booking.tour.governorate }} · {{ tourDate(booking.tour.starts_at_timestamp) }}</div>
                <div class="details-text" :class="booking.checked_in_at_timestamp ? 'success--text' : 'muted--text'">
                    {{ booking.checked_in_at_timestamp ? `تم الدخول الساعة ${tourTime(booking.checked_in_at_timestamp)}` : 'انتهت الجولة' }}
                </div>
            </template>

            <div v-else>
                <h2 class="tour-ticket__name strong-text--text mb-4">{{ booking.user.name }}</h2>

                <div class="tour-ticket__grid">
                    <div v-for="(tile, i) in tiles" :key="i" class="tour-ticket__tile" :class="{'tour-ticket__tile--wide': tile.wide}">
                        <div class="small-text muted--text mb-1">{{ tile.label }}</div>
                        <div class="tour-ticket__value strong-text--text">{{ tile.value }}</div>
                        <v-btn v-if="tile.href" :href="tile.href" :target="capRunning ? '_system' : '_blank'" rel="noopener" text small color="primary" class="px-1 mt-1">
                            <v-icon small left>mdi-map-marker-outline</v-icon>
                            افتح الخريطة
                        </v-btn>
                    </div>
                </div>

                <div class="tour-ticket__divider my-5"></div>

                <div class="text-center">
                    <div class="details-text primary--text font-weight-bold mb-2">رمز QR لدخول القاعة</div>
                    <div class="tour-ticket__qr d-inline-block pa-2 rounded-lg">
                        <qrcode :value="booking.code" :width="200" color="#000000" />
                    </div>
                    <div class="details-text primary--text font-weight-bold mt-4 mb-2">كود البوابة</div>
                    <div class="tour-ticket__code primary white--text d-inline-block ltr-dir">{{ booking.code }}</div>
                    <div class="details-text muted--text mt-4">اعرض هذا الرمز عند باب القاعة</div>
                    <div class="details-text muted--text">خذ لقطة شاشة للتذكرة لتعرضها بدون إنترنت</div>
                </div>
            </div>
        </div>

    </v-card>
</template>

<script>
import Qrcode from '@/components/default/qrcode'
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {Qrcode},
    props: {
        booking: {type: Object, required: true},
    },
    computed: {
        ...GlobalComputed,
        isPast(){
            return !!this.booking.checked_in_at_timestamp || this.booking.tour.ends_at_timestamp <= Date.now();
        },
        status(){
            if (this.booking.checked_in_at_timestamp){
                return {text: 'تم الدخول', color: 'success', icon: 'mdi-check-decagram'};
            }
            if (this.isPast){
                return {text: 'انتهت', color: 'grey', icon: 'mdi-calendar-remove-outline'};
            }
            return {text: 'مؤكد', color: 'primary', icon: 'mdi-check-circle-outline'};
        },
        tiles(){
            const {tour, user} = this.booking;
            return [
                ...this.booking.fields.filter(field => field.value).map(field => ({label: field.label, value: field.value, wide: true})),
                {label: 'المحافظة', value: tour.governorate},
                {label: 'الصف', value: user.grade || '__'},
                {label: 'التاريخ', value: this.tourDate(tour.starts_at_timestamp, false)},
                {label: 'موعد الحضور', value: `${this.tourTime(tour.starts_at_timestamp)}\nإلى ${this.tourTime(tour.ends_at_timestamp)}`.replace(/(\d) /g, '$1 ')}, // keep each time with its ص/م
                {label: 'القاعة', value: tour.address, href: tour.location_url, wide: true},
            ];
        },
    },
    methods: {
        ...GlobalMethods,
    },
}
</script>

<style lang="scss">
.tour-ticket {
    .tour-ticket__bar {
        height: 6px;
    }
    .tour-ticket__name {
        font-size: 1.45rem;
        line-height: 1.4;
    }
    .tour-ticket__grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
    }
    .tour-ticket__tile {
        background: rgba(127, 127, 127, 0.08);
        border-radius: 14px;
        padding: 10px 14px;
        min-width: 0;
        &--wide {
            grid-column: 1 / -1;
        }
    }
    .tour-ticket__value {
        font-weight: 700;
        font-size: 1.05rem;
        line-height: 1.5;
        overflow-wrap: anywhere;
        white-space: pre-line;
    }
    .tour-ticket__divider {
        border-top: 2px dashed rgba(127, 127, 127, 0.3);
    }
    .tour-ticket__qr {
        background: #fff;
        line-height: 0;
    }
    .tour-ticket__code {
        border-radius: 999px;
        padding: 8px 22px;
        font-size: 1.15rem;
        font-weight: 700;
        letter-spacing: 2px;
    }
}
</style>
